import React, { ReactElement } from 'react';
import { Logo } from './Logo';
import styled from 'styled-components';

const BrandWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const FooterLogoWrapper = styled.div`
  align-items: start;
  display: flex;
  flex-direction: column;
  width: 8rem;

  @media only screen and (min-width: 1024px) {
    width: 10rem;
  }
`;

const FooterLogoText = styled.div<{ light?: boolean }>`
  color: ${({ light }) => (light ? '#ffffff' : '#575757')};
  font-size: 10px;
  margin-bottom: 0.1rem;
`;

const CopyRightText = styled.a<{ light?: boolean }>`
  color: ${({ light }) => (light ? '#ffffff' : '#575757')};
  display: block;
  font-size: 10px;
  margin-top: 0.1rem;
  text-decoration: none;

  &:hover {
    color: ${({ light }) => (light ? '#ffffff' : '#575757')};
    text-decoration: none;
  }
`;

const LogoLink = styled.a`
  width: 100%;
`;

interface AnimatedTextProps {
  light?: boolean;
  hideCopyright?: boolean;
}

export const FooterLogo = ({
  hideCopyright,
  light,
}: AnimatedTextProps): ReactElement => {
  const currentYear = new Date().getFullYear();

  return (
    <BrandWrapper>
      <FooterLogoWrapper>
        <FooterLogoText light={light}>Powered By:</FooterLogoText>
        <LogoLink
          href="https://www.deckard.com"
          target="_blank"
          rel="noreferrer"
        >
          <Logo />
        </LogoLink>
      </FooterLogoWrapper>

      {!hideCopyright && (
        <CopyRightText
          light={light}
          href="https://www.deckard.com"
          target="_blank"
          data-testid="copyrightlink"
          rel="noreferrer"
        >
          &copy; {currentYear} deckard.com
        </CopyRightText>
      )}
    </BrandWrapper>
  );
};
